import React, {useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {Line} from 'rc-progress';
import DropZone from 'react-drop-zone'
import "./index.css";
import ReactS3Uploader from 'react-s3-uploader'
import assets from "../../../../../util/assets";

const UploadFileModal = (props) => {

    const [progress, setProgress] = useState(0);
    const [init, setInit] = useState(false);
    let uploadInput = React.createRef();
    let fileInput = React.createRef();
    let interval = null;


    const startUploading = (file) => {
        //user is retrying to upload
        if (fileInput !== null) {
            let uploaderClassName = document.getElementsByClassName("uploaderClassName")[0];

            const dt = new DataTransfer;
            dt.items.add(file);
            uploaderClassName.files = dt.files;

            fileInput.uploadFile();
        }
    }

    const getSignedUrl = (file, callback) => {
        const params = {
            objectName: file.name,
            contentType: file.type
        };

        callback({
            "signedUrl": props.signedURL
        });
    }

    const onProgress = (percent, message, file) => {
        setProgress(percent)
    }

    const onError = (message) => {
        setProgress(0);
        props.toggle();
        props.onError(message)
    }

    const onFinish = (signResult) => {
        setProgress(0);
        props.toggle();
        props.onFinish(signResult)
    }

    const initialize = (_fileInputRef) => {

        if (_fileInputRef !==null && props.file && !init && props.signedURL !== '') {
            setInit(true);
            startUploading(props.file);
        }
    }

    const getBody = () => {

        if (progress === 0) {
            return (
                <div className="upload-file-modal-body">
                    <img src={assets.clipstore.upload} alt={"upload icon"}/>
                    <div>
                        <div className="drag-and-drop-here">Drag and drop here</div>
                        <div>or <span className="primary-color cursor-pointer" onClick={() => {
                        }}>browse</span> to choose a file
                        </div>
                        <ReactS3Uploader
                            ref={(ref) => {
                                fileInput = ref;
                                initialize(ref);
                            }}
                            inputRef={cmp => uploadInput = cmp}
                            className={"uploaderClassName"}
                            getSignedUrl={getSignedUrl}
                            accept="video/*|image/*"
                            onProgress={onProgress}
                            onError={onError}
                            onFinish={onFinish}
                            uploadRequestHeaders={{}}
                            autoUpload={false}
                        />
                    </div>
                    <DropZone accept="video/*|image/*" onDrop={(file, text) => {
                        if (!props.uploadContent) {
                            startUploading(file);
                        } else {
                            //this is a create request so set the props and send the user ahead
                            props.setVideoContent(file)
                            props.history.push("/broadcaster/my-library/create")
                        }
                    }}>
                        {
                            ({over, overDocument}) =>
                                <div className="react-drop-zone-container drag-and-drop-here">
                                    {
                                        over ?
                                            'Please drop your file and it will start uploading...' :
                                            overDocument ?
                                                'Please drop your file and it will start uploading...' :
                                                ''
                                    }
                                </div>
                        }
                    </DropZone>
                </div>
            )
        } else {
            return (
                <div className="upload-file-modal-body">
                    <div className="uploading-container">
                        <div className="icons-menu-clipstore-active">
                            <img src={assets.clipstore.uploading.video} className="uploading video" width={50}/>
                        </div>
                        <div className="uploading-container-progress-container">
                            <div className="this-is-the-related">
                                {props.currentVideo.title}
                            </div>
                            <div>
                                <Line percent={progress}
                                      strokeWidth="2"
                                      strokeColor="#1B75BC"
                                      trailWidth="2"
                                      trailColor="#D8D8D8"/>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <Modal isOpen={props.isOpen}
               className="upload-file-modal-container">
            <ModalHeader className="border-0" id="upload-file-modal">
                <span className="text-center mb-2 upload-file-modal-container-title">
                    Upload
                </span>
                <img src={assets.broadcast.cross}
                     alt={"cross icon"}
                     onClick={() => {
                         if (fileInput && fileInput.hasOwnProperty("current") && fileInput) {
                             fileInput.abort();
                         }
                         props.toggle();
                     }}/>

            </ModalHeader>
            <ModalBody className="justify-content-center">
                {
                    getBody()
                }
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">

            </ModalFooter>
        </Modal>
    );
}

UploadFileModal.propTypes = {};

// Specifies the default values for props:
UploadFileModal.defaultProps = {};

export default UploadFileModal;